import { EResourceMethod } from '../models/IPermission';
import { createResourceBuilder } from '../resource';
import { userIdParam } from './builderHelper';

export const permissionResources = {
  getPermissions: createResourceBuilder('/identities/permission', EResourceMethod.Get),
  getUserPermissions: createResourceBuilder('/identities/permission/user/:user_id', EResourceMethod.Get, userIdParam()),
} as const;
